var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferred(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FEB850"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.714 10.2855L19.714 9.28553L20.714 9.28553L20.714 10.2855L19.714 10.2855ZM11.5823 19.8315C11.1917 20.222 10.5586 20.222 10.1681 19.8315C9.77753 19.441 9.77753 18.8078 10.1681 18.4173L11.5823 19.8315ZM12.6429 9.28553H19.714L19.714 11.2855H12.6429L12.6429 9.28553ZM20.714 10.2855L20.714 17.3566H18.714L18.714 10.2855L20.714 10.2855ZM20.4211 10.9926L11.5823 19.8315L10.1681 18.4173L19.0069 9.57843L20.4211 10.9926Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferred);
export default __webpack_public_path__ + "static/media/transferred.1603d824a429259dd6a70ec5e59bdb48.svg";
export { ForwardRef as ReactComponent };